const isProduction = process.env.NODE_ENV === 'production'

interface HtmxEvent extends Event {
  detail: {
    target: HTMLElement
  }
}

// import 'focus-visible'

document.addEventListener('DOMContentLoaded', () => {
  // RMOVE THIS WHEN YOU START THE PROJECT
  if (document.querySelectorAll<HTMLElement>('.body')) {
    import('utility/helpers').then((module) => module.verticalResizeCheck())
    import('components/header').then((module) => module.default.init())
    import('components/header-mobile').then((module) => module.default.init())
    // import('components/phone-app').then((module) => module.default.init())
    import('components/scrollers').then((module) => module.default.init())
    import('components/alert-banner').then((module) => module.default.init())
    import('components/chat-bubble').then((module) => module.default.init())
    import('components/valitormodal').then((module) => module.default.init())
  }

  if (document.querySelector('#cardnumber') || document.querySelector('#ccMsg')) {
    import('components/creditcardvalidation').then((module) => module.default.init())
  }

  if (document.querySelector('.excel_export')) {
    import('components/excel-export').then((module) => module.default.init())
  }

  if (document.querySelector('.filter-transactions')) {
    import('components/filter-transactions').then((module) => module.default.init())
  }

  if (document.querySelector('.video-bg')) {
    import('components/videomobile').then((module) => module.default.init())
  }

  if (document.querySelector('.key-step')) {
    import('components/keysteps').then((module) => module.default.init())
  }

  if (document.querySelector('.datepicker')) {
    import('components/datepicker').then((module) => module.default.init())
  }

  if (document.querySelector('.accordion')) {
    import('components/accordion').then((module) => module.default.init())
  }

  if (document.querySelector('.phone-app-2')) {
    import('components/phone-app-2').then((module) => module.default.init())
  }

  if (document.querySelector('.station-map') || document.querySelector('.station-map-single')) {
    import('components/map').then((module) => module.default.init())
  }

  if (document.querySelector('.cdropdown')) {
    import('components/cdropdown').then((module) => module.default.init())
  }

  if (document.querySelector('#login__username')) {
    import('components/login').then((module) => module.default.init())
  }
  if (document.querySelector('.app-slider')) {
    import('components/app-slider').then((module) => module.default.init())
  }
  if (document.querySelector('.review-slider')) {
    import('components/review-slider').then((module) => module.default.init())
  }
  if (document.querySelector('.link-spinner')) {
    import('components/link-spinner').then((module) => module.default.init())
  }
  if (document.querySelector('.hyphenate')) {
    import('components/hyphen').then((module) => module.default.init())
  }
  if (document.querySelector('input[data-validate]')) {
    import('components/form-validation').then((module) => module.default.init())
  }
  if (document.querySelector('#webloginapp')) {
    import('components/auth').then((module) => module.default.init())
  }
  if (document.querySelector('#createappkey')) {
    import('components/create-app-key').then((module) => module.default.init())
  }
  if (document.querySelector('.transactions-filter')) {
    import('components/transactions-filter').then((module) => module.default.init())
  }
  if (document.querySelector('#showInactiveAppKeys') || document.querySelector('#showInactiveKeys')) {
    import('components/hide-inactive').then((module) => module.default.init())
  }

  if (!isProduction) {
    if (document.querySelector<HTMLElement>('.overlay-grid')) {
      import('utility/overlayGrid').then((module) => module.default.init())
    }
  }

  import('utility/helpers').then((module) => module.refreshScrollTriggers())

  setTimeout(() => {
    document.querySelector('.body').classList.remove('preload')
  }, 200)
})
